import React, { useState } from 'react';
import PropTypes from 'prop-types';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import Labels from '../../components/translations/translation.json'
import { Button, Dialog, DialogContent, DialogContentText, DialogTitle, DialogActions } from '@mui/material';
//css file
import './fileTypeErrorModal.css';


function FileTypeErrorModal(props) {

  const [open] = useState(true);
  const [close] = useState(true);

  const handleClose = () => {
    props.callback(false);
  }

  return (
    <>
      <Dialog aria-labelledby="customized-dialog-title" style={{fontWeight : 'bold',fontFamily : 'Circular Book'}} className='dialog-modal' open={open}>
      <DialogTitle className="dialog-title-fileTypeRErrModal" sx={{ m: 0, p: 2 }}>
        {Labels[props.langCode].INFORMATION_MODAL}
          {close ? (
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: '#000',
              }}
            >
              <CloseIcon />
            </IconButton>
          ) : null}
        </DialogTitle>
        <DialogContent dividers className="dialog-content">
          <DialogContentText className="dialog-content-text">
            <span className="textBody-fileTypeErrModal">{Labels[props.langCode].IMAGE_FORMAT}</span>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
        <Button variant="contained" className="button-ok-fileTypeErrorModal" onClick={handleClose}>{Labels[props.langCode].OK}</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

FileTypeErrorModal.propTypes = {
  langCode: PropTypes.string,
  callback: PropTypes.func,
};

export default FileTypeErrorModal;
